import { IPreloadedState } from 'shared/types/redux';

export const selectDirectionsModal = (state: IPreloadedState) => state.geo.directionsModal;
